export const SET_TEAM = "SET_TEAM";
export const GET_TEAM = "GET_TEAM";
export const UPDATE_TEAM = "UPDATE_TEAM";
export const DELETE_TEAM = "DELETE_TEAM";
